// extracted by mini-css-extract-plugin
export var appearsOnlyInMobile = "Button-module--appearsOnlyInMobile--79e6f";
export var children = "Button-module--children--27820";
export var container = "Button-module--container--d7245";
export var disabled = "Button-module--disabled--592ae";
export var lightColor = "Button-module--lightColor--6fa5d";
export var secondary = "Button-module--secondary--d05b6";